import {
  fetchCollection
} from './index'

import { serviceSchema as schema } from '../schemas'

export const SERVICES_REQUEST = 'SERVICES_REQUEST'
export const SERVICES_SUCCESS = 'SERVICES_SUCCESS'
export const SERVICES_FAILURE = 'SERVICES_FAILURE'

export function fetchServicesForLocation (id) {
  return fetchCollection({
    url: `/locations/${id}/services`,
    key: 'services',
    actions: [SERVICES_REQUEST, SERVICES_SUCCESS, SERVICES_FAILURE],
    schema
  })
}

export function fetchServicesForWorkOrder (id) {
  return (dispatch, getState) => {
    const locationId = getState().workOrders[id].location
    return dispatch(fetchServicesForLocation(locationId))
  }
}



// WEBPACK FOOTER //
// ./src/actions/services.js